import { useFormikContext } from 'formik';

import Button from 'components/shared/Buttons/Button';

const Footer = ({ closePopover }) => {
  const { handleSubmit, isSubmitting } = useFormikContext();

  return (
    <div className="flex w-full items-center justify-between gap-2 border-0 !border-b-0 !border-t border-solid !border-neutral-100 bg-white !px-6 !py-3 shadow-[0px_-2px_16px_rgba(0,0,0,0.06)]">
      <Button text="Cancel" color="neutral" outlined onClick={closePopover} />
      <Button
        text="Export Report"
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default Footer;
